/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Pit1_TInputs */

const en_to_typescript_pit1_t = /** @type {(inputs: To_Typescript_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single sample makes every field required`)
};

const ko_to_typescript_pit1_t = /** @type {(inputs: To_Typescript_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`샘플 하나는 모든 필드를 필수로 만듭니다`)
};

const ja_to_typescript_pit1_t = /** @type {(inputs: To_Typescript_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプル 1 件はすべてのフィールドを必須にします`)
};

/**
* | output |
* | --- |
* | "A single sample makes every field required" |
*
* @param {To_Typescript_Pit1_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_pit1_t = /** @type {((inputs?: To_Typescript_Pit1_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Pit1_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_pit1_t(inputs)
	if (locale === "ko") return ko_to_typescript_pit1_t(inputs)
	return ja_to_typescript_pit1_t(inputs)
});